/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
import moment from "moment";
const momentTz = require('moment-timezone')
const lib = {};

lib.getFilterOptions = (state, getter, rootState, rootGetters) => {
  state.filter["forecast"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: [
            {
              interval: "daily",
              startOffset: 0,
              endOffset: 0,
              format: "minute",
              text: "Today",
            },
            {
              interval: "daily",
              startOffset: 1,
              endOffset: 1,
              format: "minute",
              text: "Yesterday",
            },
            {
              interval: "daily",
              startOffset: 2,
              endOffset: 0,
              format: "daily",
              text: "Last 3 days",
            },
            {
              interval: "daily",
              startOffset: 6,
              endOffset: 0,
              format: "daily",
              text: "Last 7 days",
            },
            {
              interval: "daily",
              startOffset: 29,
              endOffset: 0,
              format: "daily",
              text: "Last 30 days",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 0,
              endOffset: 0,
              format: "daily",
              text: "Present month",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 1,
              endOffset: 1,
              format: "daily",
              text: "Last month",
            },
            {
              interval: "monthly",
              offsetLevel: "month",
              startOffset: 2,
              endOffset: 0,
              format: "monthly",
              text: "Last 3 months",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 0,
              endOffset: 0,
              format: "monthly",
              text: "Present Year",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 1,
              endOffset: 1,
              format: "monthly",
              text: "Last Year",
            },
            {
              interval: "custom",
              text: "Custom",
            },
          ],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (ref.text === "Custom") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
    },
  ];

  state.filter["alert"] = [
    {
      category: "Filter",
      type: "static",
      children: [
        {
          id: "severity",
          type: "select",
          attr: { outline: false },
          title: "Severity",
          value: [
            {
              color: "red",
              icon: "error_outline",
              text: "Critical",
              value: "critical",
            },
            {
              color: "red",
              icon: "error",
              text: "High",
              value: "high",
            },
            {
              color: "red",
              icon: "bug_report",
              text: "Medium",
              value: "medium",
            },
            {
              color: "red",
              icon: "warning",
              text: "Low",
              value: "low",
            },
            {
              color: "orange",
              icon: "warning",
              text: "Warning",
              value: "warning",
            },
            {
              color: "blue",
              icon: "warning",
              text: "Info",
              value: "modbus",
            },
          ],
        },
        {
          id: "status",
          type: "select",
          title: "Status",
          value: [{ text: "New", value: "new" }, { text: "Resolved", value: "resolved" }, { text: "Acknowledge", value: "acknowledge" }],
        },
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "sortBy",
          type: "select",
          title: "Sort",
          value: [
            {
              text: "Created Time",
              value: "created_timestamp",
            },
            {
              text: "Resolved Time",
              value: "resolved_timestamp",
            },
            {
              text: "Status",
              value: "status",
            },
            {
              text: "Code",
              value: "code",
            },
          ],
        },
      ],
    },
  ];

  state.filter["inverter"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
      ],
    },
  ];

  state.filter["downTimeAnalysis"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "deviceType",
          type: "select",
          title: "Select device type",
          value: [
            { text: "Grid", value: "grid_down" },
            { text: "Inverter", value: "inv_down" },
          ],
        },
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: [
            {
              interval: "daily",
              startOffset: 1,
              endOffset: 1,
              format: "minute",
              text: "Yesterday",
            },
            {
              interval: "daily",
              startOffset: 2,
              endOffset: 0,
              format: "daily",
              text: "Last 3 days",
            },
            {
              interval: "daily",
              startOffset: 6,
              endOffset: 0,
              format: "daily",
              text: "Last 7 days",
            },
            {
              interval: "daily",
              startOffset: 29,
              endOffset: 0,
              format: "daily",
              text: "Last 30 days",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 0,
              endOffset: 0,
              format: "daily",
              text: "Present month",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 1,
              endOffset: 1,
              format: "daily",
              text: "Last month",
            },
            {
              interval: "monthly",
              offsetLevel: "month",
              startOffset: 2,
              endOffset: 0,
              format: "monthly",
              text: "Last 3 months",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 0,
              endOffset: 0,
              format: "monthly",
              text: "Present Year",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 1,
              endOffset: 1,
              format: "monthly",
              text: "Last Year",
            },
            {
              interval: "custom",
              text: "Custom",
            },
          ],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (ref.text === "Custom") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
    },
  ];

  state.filter["inverterRanking"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: [
            {
              interval: "daily",
              startOffset: 1,
              endOffset: 1,
              format: "minute",
              text: "Yesterday",
            },
            {
              interval: "daily",
              startOffset: 2,
              endOffset: 0,
              format: "daily",
              text: "Last 3 days",
            },
            {
              interval: "daily",
              startOffset: 6,
              endOffset: 0,
              format: "daily",
              text: "Last 7 days",
            },
            {
              interval: "daily",
              startOffset: 29,
              endOffset: 0,
              format: "daily",
              text: "Last 30 days",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 0,
              endOffset: 0,
              format: "daily",
              text: "Present month",
            },
            {
              interval: "daily",
              offsetLevel: "month",
              startOffset: 1,
              endOffset: 1,
              format: "daily",
              text: "Last month",
            },
            {
              interval: "monthly",
              offsetLevel: "month",
              startOffset: 2,
              endOffset: 0,
              format: "monthly",
              text: "Last 3 months",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 0,
              endOffset: 0,
              format: "monthly",
              text: "Present Year",
            },
            {
              interval: "monthly",
              offsetLevel: "year",
              startOffset: 1,
              endOffset: 1,
              format: "monthly",
              text: "Last Year",
            },
            {
              interval: "custom",
              text: "Custom",
            },
          ],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (ref.text === "Custom") {
              return true;
            } else {
              return false;
            }
          },
        },
      ],
    },
  ];

  state.filter["stringInverter"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
    },
  ];

  state.filter["zmuMonitoring"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          id: "blockList",
          type: "select",
          title: "Select Block",
          value: getter.getGeneralState("alteredFilterValues").blockList
            ? getter.getGeneralState("alteredFilterValues").blockList
            : [],
        },
      ],
    },
  ];

  state.filter["zone-monitoring"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
    },
  ];

  state.filter["otherSensors"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
    },
  ];

  state.filter["advancedStringInverter"] = [
    {
      category: "Select Date",
      type: "static",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
      ],
    },
  ];

  // May be dynamic
  state.filter["plantAnalytics"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "selectedInterval",
          type: "select",
          title: "Select an Interval",
          value: [
            { text: "1 min", value: 1 },
            { text: "5 min", value: 5 },
            { text: "15 min", value: 15 },
            { text: "30 min", value: 30 },
            { text: "1 hr", value: 60 },
            { text: "day", value: 1440 },
          ],
        },
        {
          id: "selectedTimeInterval",
          ref: "selectedInterval",
          type: "timePicker",
          title: "Select Time Range",
          condition: (ref) => !!(ref && ref.value == 1),
        },
        {
          id: "useTimeRange",
          ref: "selectedInterval",
          type: "checkbox",
          title: "Use time range",
          condition: (ref) => !!(ref && ref.value == 1),
        },
        {
          id: "DateFormat",
          ref: "selectedInterval",
          type: "select",
          title: "Select Date Format",
          value: [
            "YYYY-MM-DD HH:mm",
            "DD-MM-YYYY HH:mm",
            "HH:mm YYYY-MM-DD",
            "HH:mm DD-MM-YYYY",
          ],
          condition: (ref) => !!(ref && ref.value < 61),
        },
        {
          id: "DateFormat",
          ref: "selectedInterval",
          type: "select",
          title: "Select Date Format",
          value: ["YYYY-MM-DD", "DD-MM-YYYY"],
          condition: (ref) => !!(ref && ref.value > 60),
        },
      ],
    },
  ];

  state.filter["plantAnalyticsKpi"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "selectedInterval",
          type: "select",
          title: "Select an Interval",
          value: [
            { text: "5 min", value: 5 },
            { text: "15 min", value: 15 },
            { text: "30 min", value: 30 },
            { text: "1 hr", value: 60 },
            { text: "day", value: 1440 },
          ],
        },
        {
          id: "DateFormat",
          ref: "selectedInterval",
          type: "select",
          title: "Select Date Format",
          value: [
            "YYYY-MM-DD HH:mm",
            "DD-MM-YYYY HH:mm",
            "HH:mm YYYY-MM-DD",
            "HH:mm DD-MM-YYYY",
          ],
          condition: (ref) => !!(ref && ref.value < 61),
        },
        {
          id: "DateFormat",
          ref: "selectedInterval",
          type: "select",
          title: "Select Date Format",
          value: ["YYYY-MM-DD", "DD-MM-YYYY"],
          condition: (ref) => !!(ref && ref.value > 60),
        },
      ],
    },
  ];

  state.filter["plantAnalyticsRaw"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "selectedInterval",
          type: "select",
          title: "Select an Interval",
          value: [{ text: "day", value: 1440 }],
        },
        {
          id: "DateFormat",
          type: "select",
          title: "Select Date Format",
          value: ["YYYY-MM-DD", "DD-MM-YYYY"],
        },
      ],
    },
  ];

  // dynamic
  state.filter["weatherStation"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "datePicker",
          title: "Date",
        },
        {
          id: "wsList",
          type: "select",
          title: "Select WS",
          value: getter.getGeneralState("alteredFilterValues").wsList
            ? getter.getGeneralState("alteredFilterValues").wsList
            : [],
        },
      ],
    },
  ];

  // dynamic
  state.filter["mfm"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          id: "blockId",
          type: "select",
          title: "Select Block",
          considerStateAlways: true,
          value: getter.getGeneralState("alteredFilterValues").blockList
            ? getter.getGeneralState("alteredFilterValues").blockList
            : [],
          condition: () =>
            getter.getGeneralState("alteredFilterValues").blockList.length > 1,
        },
      ],
    },
  ];

  // dynamic
  state.filter["custom-report"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "selectedRange",
          type: "select",
          title: "Choose Date Range",
          value: rootGetters["report/getSelectedTemplate"]
            ? rootGetters["report/getRanges"]
            : [],
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "datePicker",
          title: "Select Date Range",
          condition: (ref) => {
            if (
              (ref &&
                ref.text &&
                ref.text !== "1 min" &&
                !ref.hasOwnProperty("startOffset")) ||
              ref.text === "Custom"
            ) {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          ref: "selectedRange",
          id: "Date",
          type: "singleDatePicker",
          title: "Select Date",
          condition: (ref) => {
            if (ref && ref.text && ref.text === "1 min") {
              return true;
            } else {
              return false;
            }
          },
        },
        {
          ref: "selectedRange",
          id: "DateFormat",
          type: "select",
          title: "Select Date Format",
          value: (ref) => {
            let interval = [];
            switch (ref.interval) {
              case "daily":
              case "hourly":
              case "minute":
                interval.push(
                  ...[
                    "YYYY-MM-DD HH:mm",
                    "DD-MM-YYYY HH:mm",
                    "HH:mm YYYY-MM-DD ",
                    "HH:mm DD-MM-YYYY ",
                  ]
                );
                break;
              case "monthly":
                interval.push(...["YYYY-MM-DD", "DD-MM-YYYY"]);
                break;
              case "yearly":
                interval.push(...["YYYY-MM", "MM-YYYY"]);
                break;
              case "custom":
                interval.push(
                  ...[
                    "YYYY-MM-DD HH:mm",
                    "DD-MM-YYYY HH:mm",
                    "HH:mm YYYY-MM-DD ",
                    "HH:mm DD-MM-YYYY ",
                  ]
                );
                break;
            }
            return interval;
          },
        },
      ],
    },
  ];

  // dynamic
  state.filter["advancedScb"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          id: "blockList",
          superPower: true,
          type: "select",
          title: "Select Block",
          value: getter.getGeneralState("alteredFilterValues").blockList
            ? getter.getGeneralState("alteredFilterValues").blockList
            : [],
        },
        {
          ref: "blockList",
          id: "inverterList",
          type: "selectCombo",
          title: "Select Inverters",
          value: getter.getGeneralState("alteredFilterValues").idList
            ? getter.getGeneralState("alteredFilterValues").idList
            : [],
          condition: (ref) => {
            return !!(ref && ref.text);
          },
        },
      ],
    },
  ];

  // dynamic
  state.filter["tracker"] = [
    {
      category: "Select Date",
      children: [
        {
          id: "Date",
          type: "singleDatePicker",
          title: "Date",
        },
        {
          id: "blockList",
          superPower: true,
          type: "select",
          title: "Select Block",
          value: getter.getGeneralState("alteredFilterValues").blockList
            ? getter.getGeneralState("alteredFilterValues").blockList
            : [],
        },
        {
          ref: "blockList",
          id: "trackerList",
          type: "selectCombo",
          title: "Select Trackers",
          value: getter.getGeneralState("alteredFilterValues").idList
            ? getter.getGeneralState("alteredFilterValues").idList
            : [],
          condition: (ref) => {
            return !!(ref && ref.text);
          },
        },
      ],
    },
  ];

  return state.filter;
};

lib.isUpdateFilterDb = (state) => {
  return state.updateTheDB;
};

lib.getDefaultDate = (state, getter) => {
  state.defaultDate = momentTz().tz(getter.getActivePlantInfo('timezone')).format('YYYY-MM-DD')
  return state.defaultDate;
};

lib.getShowHeaderCards = (state) => (payload) => {
  if (state.headerCards[payload] === undefined) {
    return true;
  } else {
    return state.headerCards[payload];
  }
};

lib.showDisabledFilter = (state) => (payload) => {
  if (state.filterDisabled[payload] === undefined) {
    return false;
  } else {
    return state.filterDisabled[payload];
  }
};

lib.getUserInfo = (state) => (payload) => state.userData[payload];

lib.hasPlantAssigned = (state) =>
  !!(state.plantData && Object.keys(state.plantData).length);

lib.getPlantInfo =
  (state) =>
    (info, plantId = null) => {
      const plantIdList = Array.isArray(plantId)
        ? plantId
        : plantId && plantId.constructor == String
          ? [plantId]
          : Object.keys(state.plantData);
      const infoList = Array.isArray(info) ? info : [info];

      return plantIdList.map((e) => {
        const rule = infoList.reduce((previous, current) => {
          return previous[current];
        }, state.plantData[e]);
        return rule;
      });
    };

lib.getFloatingButton = (state, getter) => (component) => {
  return (
    getter.getRules(["rule", "comp_config"])[component] &&
    getter.getRules(["rule", "comp_config"])[component].options &&
    getter.getRules(["rule", "comp_config"])[component].options.floating_button
  );
};

lib.getActivePlantInfo =
  (state, getter) =>
    (info, plantId = getter.getSelectedPlantId) => {
      if (Array.isArray(info)) {
        const rule = info.reduce((previous, current) => {
          return previous[current];
        }, state.plantData[plantId]);
        return rule;
      } else {
        return state.plantData[plantId][info];
      }
    };

lib.isUploadDisabled = (state) => (plantId) => {
  return state.plantData[plantId].rule.comp_config["upload-docs"] &&
    state.plantData[plantId].rule.comp_config["upload-docs"].options.isUpload
    ? state.plantData[plantId].rule.comp_config["upload-docs"].options.isUpload
    : false;
};

lib.getPlantList = (state) => {
  const plantList = [];
  Object.entries(state.plantData).forEach(([key, value]) => {
    plantList.push({
      id: key,
      name: value.plant_name,
    });
  });
  return plantList;
};

lib.getPlantId = (state, getter) => (plantName) => {
  return getter.getPlantList
    .filter((el) => {
      return el.name.toLowerCase().includes(plantName.toLowerCase());
    })
    .map((el) => el.id);
};

lib.getGeneralState = (state) => (payload) => {
  if (Array.isArray(payload)) {
    const rule = payload.reduce((previous, current) => {
      return previous[current];
    }, state[payload]);
    return rule;
  } else {
    return state[payload];
  }
};

lib.getRules = (state) => (payload) => {
  if (Array.isArray(payload)) {
    const rule = payload.reduce((previous, current) => {
      return previous[current];
    }, state.activePlant);
    return rule;
  } else {
    return state.activePlant[payload];
  }
};

lib.isUploadDisabled = (state) => (plantId) => {
  return state.plantData[plantId].rule.comp_config["upload-docs"] &&
    state.plantData[plantId].rule.comp_config["upload-docs"].options.isUpload
    ? state.plantData[plantId].rule.comp_config["upload-docs"].options.isUpload
    : false;
};

lib.isRenewExceeded = (state, getter) => (plantId) => {
  const renewDate = state.plantData && state.plantData[plantId] && state.plantData[plantId].renew_date;
  return renewDate && momentTz().tz(getter.getActivePlantInfo('timezone')).isAfter(moment(renewDate));
};

lib.isPlantExpired = (state, getter) => (plantId) => {
  const expiryDate =
    state.plantData &&
    state.plantData[plantId] &&
    state.plantData[plantId].expiry_date;
  return expiryDate && momentTz().tz(getter.getActivePlantInfo('timezone')).isAfter(moment(expiryDate));
};

lib.isNearingRenew = (state, getter) => (plantId) => {
  const renewDate =
    state.plantData &&
    state.plantData[plantId] &&
    state.plantData[plantId].renew_date;
  return (
    renewDate &&
    moment(renewDate).diff(momentTz().tz(getter.getActivePlantInfo('timezone')), "days") >= 0 &&
    moment(renewDate).diff(momentTz().tz(getter.getActivePlantInfo('timezone')), "days") <= 30
  );
};

lib.getExpiryDateCount = (state, getter) => (plantId) => {
  const expiryDate = getter.getPlantInfo("expiry_date", plantId)[0];
  return expiryDate
    ? moment(expiryDate).diff(momentTz().tz(getter.getActivePlantInfo('timezone')), "days") >= 0
      ? moment(expiryDate).diff(momentTz().tz(getter.getActivePlantInfo('timezone')), "days")
      : null
    : null;
};

lib.getRenewDate = (state, getter) => (plantId) => {
  const renewDate = getter.getPlantInfo("renew_date", plantId)[0];
  return renewDate || "";
};

lib.getTotalPlantCount = (state) => Object.keys(state.plantData).length;

lib.getAcCapacity = (state) => {
  const totalAcCapacity = Object.values(state.plantData).reduce(
    (sum, plantInfo) => {
      return sum + plantInfo.ac_capacity;
    },
    0
  );
  return totalAcCapacity.toFixed(2);
};

lib.getDcCapacity = (state) => {
  const totalDcCapacity = Object.values(state.plantData).reduce(
    (sum, plantInfo) => {
      return sum + plantInfo.dc_capacity;
    },
    0
  );

  return totalDcCapacity.toFixed(2);
};
lib.getPlantTotalPr = (state) => state.totalPlantPr;

lib.getModuleBrand = (state) => (plantId) => {
  return state.moduleBrand[plantId];
};

lib.getTotalGeneration = (state) => state.totalGeneration;

lib.getPlantOverviewStaticInfo =
  (state, getter) =>
    (plantId = getter.getSelectedPlantId) => {
      const selectedPlantData = state.plantData[plantId];
      const staticInfoParam =
        selectedPlantData.rule.comp_config.plant_overview.options.staticInfo;
      const staticInfo = {};
      Object.entries(staticInfoParam).forEach(([key, value]) => {
        staticInfo[key] = selectedPlantData[value];
      });

      return staticInfo;
    };

lib.getSelectedPlantId = (state) => state.activePlant.plant_id;

lib.getAllPlantCoordinates = (state) => {
  return Object.values(state.plantData).map((element) => {
    return {
      plantId: element.plant_id,
      position: {
        lat: parseFloat(element.latitude),
        lng: parseFloat(element.longitude),
      },
      plantName: element.plant_name,
    };
  });
};

lib.isComponent = (state, getter) => (componentName) => {
  let isFound =
    state.plantData[getter.getSelectedPlantId].components.search(componentName);
  return !(isFound < 0);
};

lib.isV2 = (state) => (plantId, component) =>
  !!state.plantData[plantId].rule.comp_config[component].options.v2;

lib.getBanner = (state, getter) => (component) => {
  return (
    getter.getRules(["rule", "comp_config"])[component] &&
    getter.getRules(["rule", "comp_config"])[component].options &&
    getter.getRules(["rule", "comp_config"])[component].options.banner
  );
};

lib.getNotificationTimestamp = (state) =>
  state.notifications.length > 0 ? state.notifications[0].added_on : 0;

lib.isNewNotification = (state, getter) =>
  state.userData.lastNotificationViewed < getter.latestNotificationTimestamp;

lib.getReloadTimeInMin = (state) =>
  (state.userData.refreshTime / 60000).toFixed(0);

lib.getDashboardList = (state, getters) => {
  const more = getters.getRules(["rule", "access_config"]).more;
  const devices = getters.getRules(["rule", "access_config"]).devices;
  const defaultDashboards = [
    {
      name: getters.getRules(["rule", "access_config"]).plantOverview.name,
      path: getters.getRules(["rule", "access_config"]).plantOverview.path,
    },
    {
      name: getters.getRules(["rule", "access_config"]).alert.name,
      path: getters.getRules(["rule", "access_config"]).alert.path,
    },
  ];
  return [...devices, ...more, ...defaultDashboards];
};

lib.isDashboard = (state, getters) => (path) => {
  return !!getters.getDashboardList.find((item) => item.path === path);
};

lib.isSnackBar = (state) => state.showSnackBar;

lib.getSnackBarContent = (state) => state.snackBar;

lib.isDialog = (state) => state.showDialog;

lib.getDialogContent = (state) => state.dialog;

lib.getProgressBar = (state) => state.isProgress;

lib.latestNotificationTimestamp = (state) =>
  state.notifications.length > 0 ? state.notifications[0].added_on : 0;

lib.hasNewNotification = (state, getter) =>
  state.userData.lastNotificationViewed < getter.latestNotificationTimestamp;

lib.navIsMini = (state) => state.miniNav;

lib.getLocation = (state) => (plantId) => state.plantData[plantId].state;

lib.getUserData = (state) => state.userData;

lib.getcityLocation = (state) => (plantId) => state.plantData[plantId].city;

lib.getPlantName = (state) => (plantId) => state.plantData[plantId].plant_name;

export default lib;
